import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { CommonService } from '../services/common.service';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-navigation-tab',
    templateUrl: './navigation-tab.component.html',
    styleUrls: ['./navigation-tab.component.scss'],
    imports: [NgClass]
})
export class NavigationTabComponent implements OnInit, OnChanges {
  @Input() dataInputs;
  @Input() default;
  @Output() TabChangeEvent: EventEmitter<any> = new EventEmitter();
  detailsTab: any = [];
  selectedTab: any = {name: '', data: []};
  constructor(private _CommonService: CommonService) { }

  ngOnInit() {
    console.log('this.default ', this.default);
    this.detailsTab =  this.dataInputs;
    this.selectedTab = this.detailsTab[this.default];
  }

  checkOnline(tab) {

    if (!this._CommonService.isonlineStatus) {
      if (tab.id !== 5) {
        this.changeTab(tab);
      }
    } else {
      this.changeTab(tab);
    }
  }

  changeTab(tab) {
    this.selectedTab = tab;
    this.TabChangeEvent.emit(tab);
  }

  ngOnChanges() {
    this.detailsTab =  this.dataInputs;
  }

}
